import { navigationConstants } from "./navigation.constants";
import { OrganizationType } from "../../_statics/OrganizationType";

/**
 * Builds the UPDATE_NAVIGATION_ITEMS action payload from the logged-in user.
 *
 * Centralised so every dispatch site (login, reload, setup, basic-data refresh) passes the exact same
 * fields — otherwise a site that forgets a flag (e.g. isKanzleiadmin) silently drops nav items.
 *
 * Kanzleiadmin is derived from the existing Hauptansprechpartner (mainContact) field: the user is the
 * Kanzleiadmin iff they are the main contact of their selected TAX_AGENCY organization.
 */
export const buildNavigationUpdateAction = (user) => {
    const organization = (user && user.selectedOrganization) || {};
    const isKanzleiadmin =
        organization.organizationType === OrganizationType.TAX_AGENCY &&
        !!user.externalUUID &&
        user.externalUUID === organization.mainContactExternalUUID;

    return {
        type: navigationConstants.UPDATE_NAVIGATION_ITEMS,
        userRole: user.userRole,
        allowedApps: organization.allowedApps,
        allowedModules: organization.allowedModules,
        organizationType: organization.organizationType,
        isKanzleiadmin: isKanzleiadmin,
    };
};
